import { format } from 'date-fns';
import { RoomsData, RoomsParser } from './types';

const roomsParser = (data: RoomsData): RoomsParser => ({
  date: data!.date_start ? format(data!.date_start, 'YYYY-MM-DD') : '',
  items: [
    {
      type: 'rooms',
      id: data.id,
      time: data!.date_start ? format(data!.date_start, 'HH:mm') : '',
      title: data!.subject || '',
      description: data!.description || '',
      student_url: data!.student_url || '',
      record_url: data!.record_url,
      link_state: data!.link_state,
      webinar_started: data!.webinar_started,
    },
  ],
});

export default roomsParser;



// WEBPACK FOOTER //
// ./src/services/api/remoteedu/utils/roomsParser.ts